import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Styles from '../../styles/common/pages.module.css';
// import { removeFromCart } from '../../data-access/apis/common/Carts'; // ✅ Ensure this action exists
import { AppDispatch } from '../../store';
import { removeFromCart } from '../../data-access/apis/common/Carts';

const CartItemList: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const cartData = useSelector((state: any) => state.cartItem);
  const items = cartData?.cartItems || [];

  const handleBuyNow = (url: string) => {
    if (url) window.open(url, '_blank');
  };

  const handleRemove = (productId: string) => {
    dispatch(removeFromCart(productId)); // ✅ Assumes action takes productId
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Cart Items - Mohit's Shopping App</title>
        <meta
          name="description"
          content="View all items added to your cart. Checkout your favourite products from MyShop."
        />
        <meta property="og:title" content="Cart - Mohit's Shopping App" />
        <meta
          property="og:description"
          content="View all items added to your cart. Checkout your favourite products from MyShop."
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/favicon.png`}
        />
        <meta
          property="og:url"
          content="https://mohit-online-shopping.netlify.app/cart"
        />
      </Helmet>

      <h1 className="visually-hidden">Cart - Online Shopping App</h1>

      {/* Header */}
      <section className={Styles.headSec}>
        <Container>
          <h2>Cart Items</h2>
        </Container>
      </section>

      {/* Cart Items */}
      <Container className="my-5">
        {items.length === 0 ? (
          <div className="text-center text-muted py-5">
            <h4>Your cart is empty.</h4>
            <p>Looks like you haven’t added anything yet.</p>
          </div>
        ) : (
          <Row xs={1} sm={2} md={3} lg={4} className="g-4">
            {items.map((item: any, index: number) => (
              <Col key={index}>
                <Card className="h-100 shadow-sm">
                  <Card.Img
                    variant="top"
                    src={item.image || 'https://via.placeholder.com/300x200?text=No+Image'}
                    alt={item.title || 'Product'}
                    style={{ height: '220px', objectFit: 'contain' }}
                  />
                  <Card.Body className="d-flex flex-column justify-content-between">
                    <div>
                      <Card.Title className="fs-6">
                        {item.title?.length > 60 ? item.title.slice(0, 60) + '...' : item.title}
                      </Card.Title>
                      <Card.Text className="mb-2">
                        {item.badge}
                      </Card.Text>
                    </div>

                    <div className="d-grid gap-2 mt-3">
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => handleBuyNow(item.url)}
                        disabled={!item.url}
                      >
                        Buy
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleRemove(item.productId)}
                      >
                        Remove from Cart
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </>
  );
};

export default CartItemList;














// import React from 'react';
// import { useSelector } from 'react-redux';
// import { Container, Row, Col, Card, Button } from 'react-bootstrap';
// import { Helmet } from 'react-helmet';
// import Styles from '../../styles/common/pages.module.css';

// const CartItemList: React.FC = () => {
//   const cartData = useSelector((state: any) => state.cartItem);
//   const items = cartData?.cartItems || [];

//   return (
//     <>
//       {/* SEO Meta Tags */}
//       <Helmet>
//         <title>Cart Item's - Mohit's Shopping App</title>
//         <meta
//           name="description"
//           content="View all items added to your cart. Checkout your favourite products from MyShop."
//         />
//         <meta property="og:title" content="boys Fashion - Mohit's Shopping App" />
//         <meta
//           property="og:description"
//           content="View all items added to your cart. Checkout your favourite products from MyShop."
//         />
//         <meta
//           property="og:image"
//           content={`${process.env.PUBLIC_URL}/favicon.png`}
//         />
//         <meta
//           property="og:url"
//           content="https://mohit-online-shopping.netlify.app/boys-fashion"
//         />
//       </Helmet>

//       {/* Main Heading of the Home Page */}
//       <h1 className="visually-hidden">Home - Online Shopping App & Website</h1>
//       {/* This is the First Section of Home Page */}
//       <section className={Styles.headSec}>
//         <Container>
//           <h2>Boys Fashion</h2>
//         </Container>
//       </section>

//       <Container className="my-5">
//         {items.length === 0 ? (
//           <div className="text-center text-muted py-5">
//             <h4>Your cart is empty.</h4>
//             <p>Looks like you haven’t added anything yet.</p>
//           </div>
//         ) : (
//           <Row xs={1} sm={2} md={3} lg={4} className="g-4">
//             {items.map((item: any, index: number) => (
//               <Col key={index}>
//                 <Card className="h-100 shadow-sm">
//                   <Card.Img
//                     variant="top"
//                     src={item.image || 'https://via.placeholder.com/300x200?text=No+Image'}
//                     alt={item.title || 'Product'}
//                     style={{ height: '200px', objectFit: 'contain' }}
//                   />
//                   <Card.Body>
//                     <Card.Title className="fs-6">
//                       {item.title?.length > 60
//                         ? item.title.slice(0, 60) + '...'
//                         : item.title || 'Untitled Product'}
//                     </Card.Title>
//                     <Card.Text>
//                       <strong>Price:</strong> ₹{item.price || 'N/A'}
//                     </Card.Text>
//                     <Button variant="outline-danger" size="sm" className="w-100">
//                       Remove from Cart
//                     </Button>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             ))}
//           </Row>
//         )}
//       </Container>
//     </>
//   );
// };

// export default CartItemList;
